export default __webpack_public_path__ + "static/newsletter-2b3d324e4392566b2a14e469e50a105b.svg";